// File: src/components/ClassTabs.js
// Which class of a series you are looking at.
//
// Renders nothing at all for a series with one class. That is not a tidiness
// nicety - every series that existed before classes did was given exactly one,
// named after itself, so a strip that appeared for them would show a single
// tab repeating the series name directly under the series name. Hiding it is
// what makes those series look exactly as they always did.

import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

function ClassTabs({ classes = [], selectedClassId, onSelect }) {
  const { t } = useLanguage();

  if (classes.length < 2) return null;

  return (
    <div className="mb-4" role="tablist" aria-label={t('seriesClasses')}>
      <div className="flex flex-wrap gap-2">
        {classes.map(cls => {
          const active = cls.id === selectedClassId;
          return (
            <button
              key={cls.id}
              role="tab"
              aria-selected={active}
              onClick={() => onSelect(cls.id)}
              className={`px-4 py-2 rounded font-semibold text-sm transition-colors ${
                active
                  ? 'bg-accent text-accent-ink'
                  : 'bg-paper-alt text-ink-muted hover:text-ink border border-line'
              }`}
            >
              {cls.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default ClassTabs;
